import React from 'react';
import PropTypes from 'prop-types';

const SaveMoney = ({ color = '#224251', secondaryColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={color}
        d="M8.582 12.299a.93.93 0 1 1-1.86 0 .93.93 0 0 1 1.86 0Zm1.411-1.855a8.183 8.183 0 0 1 2.264-.315c.826 0 1.616.12 2.348.338a.62.62 0 0 0 .354-1.188 9.424 9.424 0 0 0-2.701-.39c-.91 0-1.787.128-2.607.362a.62.62 0 1 0 .342 1.193Z"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.39 7c-3.931 0-7.356 2.317-8.345 5.61H3.32c-.193 0-.383.044-.557.128a1.325 1.325 0 0 0-.453.357 1.4 1.4 0 0 0-.29 1.108l.336 1.986c.08.474.32.903.677 1.212.357.31.808.48 1.275.479h.347c.396.698.908 1.33 1.512 1.88l-.963 3.368a.7.7 0 0 0 .105.6.644.644 0 0 0 .529.272h2.64c.137 0 .27-.043.38-.124a.678.678 0 0 0 .242-.328l.637-1.837c.838.235 1.73.363 2.655.363.934 0 1.833-.129 2.678-.37l.717 1.866a.676.676 0 0 0 .242.312c.11.077.24.118.372.118h2.64a.644.644 0 0 0 .53-.275.693.693 0 0 0 .101-.602l-1.004-3.408c1.441-1.334 2.352-3.151 2.352-5.178 0-.198-.008-.393-.026-.586.345-.15.67-.362.93-.604.417.416 1.077.416 1.077-.567 0 .303-.66.303-.609-.035.055-.11.095-.227.12-.347a.98.98 0 0 0-.268-.877.746.746 0 0 0-.933-.133.987.987 0 0 0-.337.32c-.086.133-.14.285-.158.444-.032.33.108.653.422.89a2.619 2.619 0 0 1-.342.207C20.19 9.626 16.56 7 12.39 7Zm-7.194 6.437c.601-2.81 3.522-5.077 7.194-5.077 4.154 0 7.31 2.875 7.31 6.177 0 1.706-.825 3.278-2.206 4.417a.7.7 0 0 0-.218.728l.872 2.958h-1.3l-.78-2.022a.672.672 0 0 0-.339-.368.642.642 0 0 0-.491-.024 8.443 8.443 0 0 1-2.848.488 8.485 8.485 0 0 1-2.848-.488.642.642 0 0 0-.502.029.673.673 0 0 0-.337.384L8.01 22.64H6.717l.836-2.924a.7.7 0 0 0-.004-.399.68.68 0 0 0-.22-.327 6.285 6.285 0 0 1-1.696-2.096.673.673 0 0 0-.243-.273c.776-.26-.223-.1-.345-.101h-.74a.649.649 0 0 1-.424-.16.685.685 0 0 1-.225-.403l-.336-1.986h1.232c.15 0 .296-.053.414-.15a.683.683 0 0 0 .23-.384Zm16.665-1.166a.827.827 0 0 1-.13.286l-.058-.034c-.193-.122-.207-.238-.2-.303a.332.332 0 0 1 .154-.236c.065-.036.106-.028.149.017a.278.278 0 0 1 .084.27Z"
        clipRule="evenodd"
      />
      <path
        fill={secondaryColor}
        stroke={color}
        d="M6.482 8.311c.12.044.229.091.312.141.125.075.28.204.427.343l-.444.374-.295-.858Z"
      />
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth={0.6}
        d="m11.907 1.754.844 3.15m.19-2.443c-.098-.362-.53-.561-.964-.445-.435.117-.709.505-.612.867.097.363.529.562.964.446.435-.117.866.083.963.445.097.362-.177.75-.612.867-.435.117-.866-.083-.963-.445"
      />
      <path stroke={color} strokeLinecap="round" strokeWidth={0.6} d="M10.407 1.407a2.718 2.718 0 1 1-.704 1.22" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={secondaryColor} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

SaveMoney.propTypes = {
  color: PropTypes.string,
  secondaryColor: PropTypes.string
};

export default SaveMoney;
